import { WhatsappLogo } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { SOCIAL_LINKS } from "@/lib/i18n";

export const WhatsAppWidget = () => (
  <motion.a
    data-testid="whatsapp-widget"
    href={SOCIAL_LINKS.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 0.5 }}
    className="fixed bottom-6 left-6 z-40 w-14 h-14 bg-[#25D366] flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/60 transition-shadow duration-300 group"
  >
    <span className="absolute inset-0 bg-[#25D366] animate-ping opacity-30" />
    <WhatsappLogo
      size={26}
      weight="fill"
      className="relative text-white group-hover:scale-110 transition-transform duration-200"
    />
  </motion.a>
);
